module.exports = __webpack_public_path__ + "static/media/okitask.970bc497.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/okitask.png
// module id = 742
// module chunks = 0